import { render, staticRenderFns } from "./TreatmentTakeRow.vue?vue&type=template&id=cf6f4744&scoped=true&"
import script from "./TreatmentTakeRow.vue?vue&type=script&lang=ts&"
export * from "./TreatmentTakeRow.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentTakeRow.vue?vue&type=style&index=0&id=cf6f4744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6f4744",
  null
  
)

export default component.exports